import { TechnicalError } from '../../common/errors';

import Result from '../../common/result';
import { TokenResult } from '../../services/common/token';
import BaseToken from './BaseToken';

export default class OneTimeToken extends BaseToken {
  override async getToken(): Promise<TokenResult> {
    if (this.isTokenValid()) {
      return Result.successful(this.token);
    }

    return Result.failed(new TechnicalError('Cannot renew one time token'));
  }
}
